import * as Sentry from '@sentry/react'
import { AppProviders } from '@/providers/app-providers'
import { AppRoutes } from '@/routes'
import { SentryErrorFallback } from '@/components/sentry-error-fallback'

function App() {
  return (
    <Sentry.ErrorBoundary fallback={SentryErrorFallback}>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </Sentry.ErrorBoundary>
  )
}

export default App
